<template>
  <div v-if="loanRequest != 'undefined' && carregado">
    <div v-if="!loanRequest.Encerrado">
      <div v-if="canInvest">
        <div class="row no-gutters text-center">
          <div class="col-12 text-center">

            <!--LISTA DE ESPERA -->
            <div v-if="this.indiceShowForm == 0" class="alert alert_reserve alert-warning text-center" role="alert">
              <h2>Tem interesse em investir nesta empresa?</h2>
              <div>
                <p class="queue-message-paragraph">
                  <strong>Clique no botão</strong> abaixo e coloque sua oferta na lista de espera. Enquanto estamos esperando a transferência
                  de recursos você ainda pode ser um dos investidores.</p>
                <a href="#" @click.prevent="abreModal()" class="btn btn-lg btn-primary btn-block">LISTA DE ESPERA</a>
              </div>
            </div>

            <!--INVESTIMENTO -->
            <form v-show="this.indiceShowForm == 1">
              <div class="form-group">
                <label for="valor">Deseja investir nesta empresa?</label>
                <input v-if="!this.TemLimitadorMaximoInvestimento(loanRequest.InvestimentoMaximo)" v-model="valorInvestimento" v-on:keyup="CalculaInformacoesGerais()" v-on:click="MostrarRelatorio()" class="form-control form-control-lg"
                  id="valor" :placeholder="'Investimento mínimo de R$ ' + formatCurrency(loanRequest.InvestimentoMinimo)" v-mask="'money'">
              </div>
            </form>

            <!-- <at-select v-show="this.indiceShowForm == 1" size="large" v-model="selected" placeholder="Selecione um valor ..." v-if="this.TemLimitadorMaximoInvestimento(loanRequest.InvestimentoMaximo)" id="exampleFormControlInput1">
              <at-option  v-for="option in values" :key="option" :value="option">{{ option }}</at-option>
            </at-select> -->

            <form v-show="this.indiceShowForm == 1">
              <button v-if="this.InvestidorBloqueado()" class="btn btn-lg btn-danger btn-block" style="cursor: not-allowed;" disabled>Bloqueado</button>
              <button v-if="!this.InvestidorBloqueado()" class="btn btn-primary btn-lg btn-block" id="btnInvestir" @click.prevent="abreModal()">{{investmentId ? 'Alterar Valor' : 'Investir'}}</button>
            </form>

            <!--CONFIRMADO -->
            <div class="confirm" v-show="this.indiceShowForm == 3">
              <img src="/static/assets/images/ico-confirm.svg" alt="icone de confirmação">
              <p>
                Investimento registrado com sucesso.
                <br/>
                <small v-if="this.Status==2">
                  Parabéns, você entrou na lista de espera. Caso tenhamos alguma desistência, você será chamado para confirmar o seu investimento e receberá as instruções por e-mail.
                </small>
                <small v-else-if="!investmentPaid">
                  Pagamento já realizado! Seu investimento foi gerado com sucesso e enviado para o seu e-mail, assim como as informações referentes ao seu investimento.
                </small>
                <small v-else>
                  Seu boleto bancário já foi gerado com sucesso e enviado para o seu e-mail, assim como as informações referentes ao seu investimento.
                </small>
                  <!-- depois de adicionar a função, remover a tag span deixar os br e o link para cancelar investimento. -->
                <span>
                  <a  v-if="investmentPaid" href="#" class="btn btn-danger btn-lg btn-block" @click.prevent="abreModal()">Cancelar investimento</a>
                  <!-- A função principal é habilitar um modal com 3 itens: Titulo -> Desistência de investimento | Texto de descrição sobre as consequências da desistência | Textarea para o investidor informar o motivo e o botão CANCELAR. Usar o mesmo modal já existente no site. -->
                </span>
              </p>
            </div>

            <!-- ENCERRADO -->
            <div class="confirm" v-show="this.indiceShowForm == 4">
              <p>
                Oportunidade encerrada:
                <br/>
                <small>
                  Sua reserva de investimento foi realizada com sucesso. Efetue o pagamento do boleto enviado para o seu e-mail para confirmar o seu investimento ou clique abaixo para cancelar sua reserva.
                </small>
              </p>
            </div>

            <p class="small" v-if="verificaMsg2()">
              **Ao confirmar o seu investimento, o boleto é gerado imediatamente e o pagamento do valor investido deve ser realizado em até 24 horas.
            </p>
            <p class="small" v-else>
              **Caso você seja chamado pela lista de reserva, você receberá as instruções por e-mail e o pagamento do valor investido deve ser realizado em 24 horas.
            </p>
          </div>
        </div>

        <!-- <div class="row no-gutters text-center" v-if="!isSuitable">
          <div class="col-12">
            <div class="alert alert-warning" role="alert">
              O seu <strong>perfil de risco</strong> não é adequado para investir nesta empresa.
            </div>
          </div> -->
        <!-- <div class="row text-center" style="margin-top: 20px;" v-if="resumoVisivel">
          <div class="col-12">
            <at-collapse accordion simple :value="valueToInvest">
              <at-collapse-item name="collapse1">
                <div slot="title" @click.prevent="CalculaInformacoesGerais()">Resumo previsto de investimento</div>
                <div class="row">
                  <div class="no-gutters box box_collapse">
                    <div class="col-12 text-center">
                      <label class="title">Valor da oferta</label>
                      <span class="value">R$ {{formatCurrencyInv()}}</span>
                    </div>
                    <hr class="divider">
                    <div class="row no-gutters">
                      <div class="col-12 col-md-6 text-center">
                        <label>Retorno Bruto Anual</label>
                        <span class="info bold">{{formatCurrency(retornoBrutoAnual)}}% a.a.</span>
                      </div>
                      <div class="col-12 col-md-6 text-center">
                        <label>Retorno Bruto Mensal</label>
                        <span class="info bold">{{formatCurrency(retornoBrutoMensal)}}% a.m.</span>
                      </div>
                      <div class="col-12 text-center">
                        <p class="small">
                          ¹ A taxa de retorno líquida será a taxa bruta descontada do imposto de renda.
                        </p>
                      </div>
                    </div>
                    <hr class="divider">
                    <div class="col-12">
                      <h3>Informações Gerais</h3>
                      <ul class="list-group">
                        <li class="list-group-item">
                          <span class="float-left text-secondary">Plano de pagamento</span>
                          <span class="float-right font-weight-bold">{{prazo}} parcelas² de R$ {{this.formatCurrency(valorParcela)}}</span>
                        </li>
                        <li class="list-group-item">
                          <span class="float-left text-secondary">Retorno bruto</span>
                          <span class="float-right font-weight-bold">R$ {{this.formatCurrency(retornoBrutoFormatado)}}</span>
                        </li>
                        <li class="list-group-item">
                          <span class="float-left text-secondary">Imposto de renda total</span>
                          <span class="float-right font-weight-bold">R$ {{this.formatCurrency(impostoRendaTotalFormatado)}}</span>
                        </li>
                        <li class="list-group-item">
                          <span class="float-left text-secondary">Retorno total líquido</span>
                          <span class="float-right font-weight-bold">R$ {{this.formatCurrency(retornoLiquidoFormatado)}}</span>
                        </li>
                      </ul>
                      <p class="small">² Pagamento da primeira parcela : aproximadamente 1 mês depois da assinatura dos contratos.</p>
                    </div>
                  </div>
                </div>
              </at-collapse-item>
            </at-collapse>
          </div>
        </div> -->
      </div>
      <div v-else class="alert alert_reserve alert-warning text-center">
        <h2>Falta pouco para você investir</h2>
        <div>
          <p v-if="hasInvestor && hasSuitability && !isInvestorApproved">Agora estamos analisando suas informações e retornaremos em até 1 dia útil.</p>
          <p v-else>
            <router-link v-if="!hasInvestor" to="/informacoes-adicionais/investidor" class="btn btn-link">Complete o cadastro de investidor</router-link>
            <router-link v-if="!hasSuitability" to="/informacoes-adicionais/suitability" class="btn btn-link">Preencha o formulário de suitability</router-link>
          </p>
        </div>
      </div>
    </div>
    <div v-else>
      <div class="alert alert_reserve alert-dark text-center" role="alert">
        <h2 style="color: #555;">Oportunidade encerrada</h2>
      </div>
    </div>
  </div>
</template>

<style>
  .company-view aside .alert p,
  .loans-details aside .alert p,
  .all-tickets aside .alert p .queue-message-paragraph {
    padding: 2em 0;
  }


  @media screen and (max-width: 575px) {
    .company-view aside .alert h2 {
      font-size: 18px !important;
    }

    .company-view aside .alert p {
      font-size: 13px !important;
    }
  }
</style>

<style lang="scss" scoped>
  @import "../../assets/styles/iouu/mixins";
  @import "../../assets/styles/iouu/variables";
  .alert {
    h2 {
      color: #856404 !important;
      @include font-size(24px);
      padding-bottom: 10px;
    }
    p {
      padding: 0px !important;
    }
    .btn {
      margin-top: 0px;
    }
    a:hover {
      color: #856404;
    }
  }

  .botao-reinvestir-saldo {
    background-color: rgb(35, 204, 182) !important;
  }

  .reinvestir {
    border-bottom: 1px solid #DDDDDD;
    margin-bottom: 25px;
    padding-bottom: 20px;

    img {
      width: 60px;
    }

    p {
      font-size: 16px;
      font-weight: normal;
      color: #000;
      padding: 20px 0;
    }

    label {
      color: #888;
      font-size: 14px;
      line-height: 14px;
    }
    span {
      font-weight: 700;
      font-size: 25px;
      line-height: 25px;
    }
  }

  .error {
    input {
      border-color: red;
      color: red;
      margin-bottom: 5px;
      &::placeholder {
        color: red;
      }
    }

    p.small {
      padding: 0px;
      margin: 0px;
      font-size: 12px;
      color: red;
    }
  }
</style>


<script>
  /* eslint-disable */
  import Masker from '@/utils/masker'
  import ApiClient from '../../utils/api-client'
  import ArrayHelper from "@/utils/array-helper";

  export default {
    props: {
      loanRequest: {
        required: true
      },
      investmentConfirmed: {
        required: true,
        type: Boolean
      },
    },
    data() {
      return {
        selected: "",
				values:[],
        totalLiquidoIR: 0,
        totalRetornoBruto: 0,
        valorInvestimento: undefined,
        valorReinvestimento: undefined,
        valorParcela: 0,
        impostoRendaTotalFormatado: 0,
        retornoBrutoFormatado: 0,
        retornoLiquidoFormatado: 0,
        investment: {},
        showQueueForm: false,
        liberaFormValor: false,
        indiceShowForm: 1,
        carregado: false,
        Status: 1,
      }
    },
 
    /*TODO: FAZER ISSO: */
    beforeCreate() {
     var solicitacaoId = this.$route.params.id

        ApiClient.getInvestmentReservation({
            loanRequestId: solicitacaoId
          })
          .then(investmentReservation => {
            this.investment = investmentReservation;

            if (this.investment != null) {
              this.Status = this.investment.Status;
              this.valorInvestimento = this.formatCurrency(this.investment.Valor);
            }

            this.AjustaTela();

            this.CalculaInformacoesGerais();

            this.carregado = true;
          }).catch(error => {
            console.log('error', error)
          })
    },
    created() {

      this.values = [];
      let valorSelect = 0;
      let valorRestante = this.loanRequest.Valor - this.loanRequest.ValorCaptado;
      let quantidade = (this.loanRequest.InvestimentoMaximo / this.loanRequest.InvestimentoMinimo);

      for(let i=1; (i <= quantidade && valorRestante > valorSelect ) ; i++) {
        this.values.push("R$ " + (this.loanRequest.InvestimentoMinimo * i).toLocaleString('pt-BR', {minimumFractionDigits: "2", maximumFractionDigits: 2}) );
        valorSelect = this.loanRequest.InvestimentoMinimo * i;
      }

      if(this.investmentConfirmed) {
        for(let i=1; i <= quantidade; i++) {
          this.values.push("R$ " + (this.loanRequest.InvestimentoMinimo * i).toLocaleString('pt-BR', {minimumFractionDigits: "2", maximumFractionDigits: 2}) );
        }
      }
    },
    computed: {
      investmentPaid() {
        if(this.investment)
          return this.investment.Valor == this.investment.ReInvestimento || this.investment.StatusBoleto == 'paid' ? false : true
        return true
      },
      User: function () {
        return this.$store.state.currentUser;
      },
      minPercentToQueue() {
        return this.$config.investment.minPercentToQueue
      },
      valueToInvest() {
        if (this.investment)
          return this.formatCurrency(this.investment.Valor)

        return 0;
      },
      resumoVisivel(){

        if (this.loanRequest && this.loanRequest.ResumoVisivel != undefined)
          return this.loanRequest.ResumoVisivel;

          return true;
      },
      valueToInvestNaoFormatado() {
        if (this.investment)
          return this.investment.Valor;

        return 0;
      },
      retornoBrutoMensal() {
        return this.loanRequest.RetornoBrutoMensal;
      },
      retornoBrutoAnual() {
        return this.loanRequest.RetornoBrutoAnual;
      },
      taxaInternaRetorno() {
        return this.loanRequest.TaxaInternaRetorno
      },
      taxaTotalEfetiva() {
        return this.loanRequest.TaxaTotalEfetiva
      },
      prazo() {
        return this.loanRequest.Prazo
      },
      investmentId() {
        return this.investment ? this.investment._id : 0;
      },
      currentUser() {
        return this.$store.state.currentUser
      },
      hasInvestor() {
        return this.currentUser.hasinvestor
      },
      hasSuitability() {
        return this.currentUser.hassuitability
      },
      isInvestorApproved() {
        return this.hasInvestor && (this.currentUser.investor != null && this.currentUser.investor.Status == 'APROVADO')
      },
      canInvest() {
        return this.hasInvestor && this.hasSuitability && this.isInvestorApproved
      },
      reachedValuePercentage() {
        return Number.parseInt((this.loanRequest.ValorCaptado * 100) / this.loanRequest.Valor)
      },
      startedQueue() {
        return this.reachedValuePercentage >= this.minPercentToQueue
      },
      shouldShowQueueNotification() {
        return this.startedQueue && !this.showQueueForm && !this.investmentConfirmed
      },
      shouldShowReservationForm() {
        return (!this.investmentConfirmed && (!this.startedQueue || this.showQueueForm))
      },
      investorSuitability() {
        return this.canInvest ? this.$store.state.currentUser.suitability.Tipo : null
      },
      isSuitable() {
        return this.loanRequest.PerfisAptos.includes(this.investorSuitability)
      },
      retornoBruto() {
        const interest = (Math.pow((1 + (this.taxaTotalEfetiva / 100)), this.prazo)) - 1
        const interestValue = Masker.unmaskMoney(this.valueToInvest) * interest
        return Masker.unmaskMoney(this.valueToInvest) + interestValue
      },
      impostoRendaTotal() {
        const years = Math.round(this.prazo / 12)
        const interest = (Math.pow((1 + (this.loanRequest.TaxaImpostoRenda / 100)), years)) - 1
        const gainValue = this.retornoBruto - Masker.unmaskMoney(this.valueToInvest)
        return gainValue * interest
      },
    },
    methods: {
      abreModal(){
        this.selected = this.loanRequest.InvestimentoMinimo.toString()
        this.$emit('submit', this.selected)
      },
      verificaMsg(){
        if(this.Status === 2) {
          return false
        }

        return true
      },

      verificaMsg2() {

        if(this.Status === 1 || this.loanRequest.ValorCaptado < this.loanRequest.Valor){
          return true
        }

        return false
      },
      InvestidorBloqueado() {

        	if(this.currentUser.investor == null ||  this.currentUser.investor.Bloqueio == null  ||this.currentUser.investor.Bloqueio.FimBloqueio == null)
					return false;
        
				var  FimBloqueio= new Date(this.currentUser.investor.Bloqueio.FimBloqueio)
				
				return (FimBloqueio > (new Date()));
			},

      Block(isBlock)
			{
        
				$("#btnInvestir").prop( "disabled", isBlock );

				if(isBlock)
					$("#lnkNaoUsarSaldo").hide();
				else
					$("#lnkNaoUsarSaldo").show();
					
				$("#btnUsarSaldo").prop( "disabled", isBlock );
			},
      MostrarRelatorio() {


        if (document.getElementById("valor") !== undefined) {

          document.getElementById("valor").addEventListener("keyup", () => {
            if (!document.getElementsByClassName("at-collapse__item")[0].classList.contains(
                'at-collapse__item--active')) {
              document.getElementsByClassName("at-collapse__item")[0].classList.add("at-collapse__item--active");
              document.getElementsByClassName("at-collapse__item")[0].classList.add("keyPress");
              document.getElementsByClassName("at-collapse__body")[0].removeAttribute("style");
            }
          });
        }

        if  (this.selected != null && this.selected != "") {
          document.getElementsByClassName("at-collapse__item")[0].classList.add("at-collapse__item--active");
          document.getElementsByClassName("at-collapse__body")[0].removeAttribute("style");
        }
      },
      CalculaInformacoesGerais() {

        var valor;
        if (document.getElementById("valor") == undefined) {
          valor = "0,00";

        } else {
          valor = document.getElementById("valor").value;
        }

        if(this.selected != null && this.selected != "") {
          valor = this.selected.trim().replace("R$", "");
          valor = valor.replace(".", "")
        }

        valor = valor.replace(/[^0-9]/g, "")
        valor = valor.substring(0, valor.length - 2) + "." + valor.substring(valor.length - 2);

        var novoValor = parseFloat(valor);
        this.valorParcela = -this.PMT(this.loanRequest.RetornoBrutoMensal / 100, this.prazo, novoValor);
        this.retornoBrutoFormatado = this.RetornoBruto(this.prazo, this.loanRequest.RetornoBrutoMensal / 100, novoValor);
        this.impostoRendaTotalFormatado = this.ImpostoRendaTotal(this.prazo, this.loanRequest.RetornoBrutoMensal / 100,
          novoValor);
        this.retornoLiquidoFormatado = this.RetornoTotalLiquido();
      },
      formatCurrencyInv() {

        if (document.getElementById("valor") != undefined) {
          var valor = document.getElementById("valor").value;

          if (valor == "")
            valor = "0,00";

          if(this.selected != null && this.selected != "") {
            valor = this.selected.trim().replace("R$", "");
            valor = valor.replace(".", "")
          }

          valor = valor.replace(/[^0-9]/g, "")
          valor = valor.substring(0, valor.length - 2) + "." + valor.substring(valor.length - 2);

          var novoValor = parseFloat(valor);
          return novoValor.toLocaleString('pt-BR', {
            minimumFractionDigits: "2",
            maximumFractionDigits: 2
          })
        }

        return this.valorInvestimento;
      },
			TemLimitadorMaximoInvestimento(InvestimentoMaximo) {
				if( InvestimentoMaximo!==0 &&
            InvestimentoMaximo!==null &&
            InvestimentoMaximo!==undefined 
            ){
    					return true;
            }
				return false;
			},

      formatCurrency(value) {

        if (!isNaN(parseFloat(value)) && isFinite(value))
          return value.toLocaleString('pt-BR', {
            minimumFractionDigits: "2",
            maximumFractionDigits: 2
          });
        else {
          value = 0;
        }
        return value.toLocaleString('pt-BR', {
          minimumFractionDigits: "2",
          maximumFractionDigits: 2
        });;
      },

      submit() {
        let value
        this.valorReinvestimento ? value = this.valorReinvestimento : value = "0,00"
        if(value.indexOf(',') == value.length - 2){
          value = value.replace(/\D/g, '')
          value = value.substr(0,(value.length - 2))+','+value.substr(value.length - 2, value.length)
        }
        var val = Masker.unmaskMoney(this.valorInvestimento);
        var valReInv = Masker.unmaskMoney(value);

        if (this.loanRequest.InvestimentoMinimo == 0) {
          this.loanRequest.InvestimentoMinimo = 500;
        }

        if (val < this.loanRequest.InvestimentoMinimo || val % this.loanRequest.InvestimentoMinimo != 0) {

          this.$Notify.error("Valor deve ser de pelo menos R$ " + this.formatCurrency(this.loanRequest.InvestimentoMinimo) +
            " e deve ser multiplo de R$ " + this.formatCurrency(this.loanRequest.InvestimentoMinimo));
        }

        if (valReInv > val) {
          valReInv = val;
          this.Block(false);
        } else {
          this.$emit('submit', {
            _id: this.investment != null ? this.investment._id : null,
            Valor: val,
            ReInvestimento: valReInv
          });

          this.Block(false);

          this.indiceShowForm = 3; //enviar para investimento realizado com sucesso
          this.liberaFormValor = false;
        }
      },

      ValidarInvestimento() {

        var value = 0
        if (typeof this.valorInvestimento === 'string') {
          var inv = this.valorInvestimento.replace(/[^a-zA-Z0-9 ]/g, "");
          value = parseFloat(inv / 100);
        }

        if (value == 0 || isNaN(value)) {
          this.$Notify.error({
            title: "Desculpe",
            message: "Por favor, insira um valor."
          });

          return false;
        }

        if (value < this.loanRequest.InvestimentoMinimo || isNaN(value)) {
          this.$Notify.error({
            title: "Desculpe",
            message: "O valor mínimo de aporte é de R$ " + this.formatCurrency(this.loanRequest.InvestimentoMinimo)
          });

          return false;
        }
        if (value > this.loanRequest.InvestimentoMaximo && this.loanRequest.InvestimentoMaximo != 0 || isNaN(value)) {

          this.$Notify.error({
            title: "Desculpe",
            message: "O valor máximo de aporte é de R$ " + this.formatCurrency(this.loanRequest.InvestimentoMaximo)
          });

          return false;
        }

        if ((value % this.loanRequest.InvestimentoMinimo != 0) || isNaN(value)) {
          this.$Notify.error({
            title: "Desculpe",
            message: "O valor deve ser multiplo de R$ " + this.formatCurrency(this.loanRequest.InvestimentoMinimo)
          });

          return false;
        }


        if (this.investment != null && this.investment.Valor > 0) {

          if (value > this.loanRequest.Valor ) {
						this.$Notify.error({
							title: "Desculpe",
							message: "O valor de aporte é maior que o solicitado."
						});

						return false;
					}

          if ( value > (this.loanRequest.Valor - this.loanRequest.ValorCaptado + this.investment.Valor)) {
            this.$Notify.error({
              title: "Desculpe",
              message: "O valor de aporte é maior que o disponível."
            });

            return false;
          }

        } else {


       if (value > this.loanRequest.Valor ) {
						this.$Notify.error({
							title: "Desculpe",
							message: "O valor de aporte é maior que o solicitado."
						});

						return false;
				}

          //verifica se existe saldo, caso ñ é porque esta na lista de espera
          if ( ((this.loanRequest.Valor - this.loanRequest.ValorCaptado) > 0) &&  value > (this.loanRequest.Valor - this.loanRequest.ValorCaptado)) {
            this.$Notify.error({
              title: "Desculpe",
              message: "O valor de aporte é maior que o disponível."
            });

            return false;
          }
        }


        return true;

      },
      AjustaTela() {

        if (this.shouldShowQueueNotification) {
          this.indiceShowForm = 0; // mostra a lista de espera
        }

        if (this.investmentConfirmed) {
          this.indiceShowForm = 3;
        }
      },

      FV(rate, periods, payment, value, type) {
        // Credits: algorithm inspired by Apache OpenOffice

        // Initialize type
        type = (typeof type === 'undefined') ? 0 : type;

        // Evaluate rate (TODO: replace with secure expression evaluator)
        rate = eval(rate);

        // Return future value
        var result;
        if (rate === 0) {
          result = value + payment * periods;
        } else {
          var term = Math.pow(1 + rate, periods);
          if (type === 1) {
            result = value * term + payment * (1 + rate) * (term - 1.0) / rate;
          } else {
            result = value * term + payment * (term - 1) / rate;
          }
        }

        // result = Math.round(result * 100) / 100;

        return -result;
      },

      IPMT(rate, period, periods, present, future, type) {
        // Credits: algorithm inspired by Apache OpenOffice

        // Initialize type
        type = (typeof type === 'undefined') ? 0 : type;

        // Initialize future
        future = (typeof future === 'undefined') ? 0 : future;

        // Evaluate rate and periods (TODO: replace with secure expression evaluator)
        rate = eval(rate);
        periods = eval(periods);

        // Compute payment
        var payment = this.PMT(rate, periods, present, future, type);

        // Compute interest
        var interest;
        if (period === 1) {
          if (type === 1) {
            interest = 0;
          } else {
            interest = -present;
          }
        } else {
          if (type === 1) {
            interest = this.FV(rate, period - 2, payment, present, 1) - payment;
          } else {
            interest = this.FV(rate, period - 1, payment, present, 0);
          }
        }

        var result = interest * rate;
        // result = Math.round(result * 100) / 100;

        // Return interest
        return interest * rate;
      },

      PMT(rate, periods, present, future, type) {
        // Credits: algorithm inspired by Apache OpenOffice

        // Initialize type
        type = (typeof type === 'undefined') ? 0 : type;

        // Initialize future
        future = 0;

        // Evaluate rate (TODO: replace with secure expression evaluator)
        rate = eval(rate);

        // Return payment
        var result;
        if (rate === 0) {
          result = (present + future) / periods;
        } else {
          var term = Math.pow(1 + rate, periods);
          if (type === 1) {
            result = (future * rate / (term - 1) + present * rate / (1 - 1 / term)) / (1 + rate);
          } else {
            result = future * rate / (term - 1) + present * rate / (1 - 1 / term);
          }
        }

        // result = Math.round(result * 100) / 100;

        return -result;
      },

      ImpostoRendaTotal(totalParcelas, taxa, totalInvestido) {
        var sum = 0;

        for (var periodo = 1; periodo <= totalParcelas; periodo++) {
          var aliqIR = 0;
          var IR = 0;
          var ipmt = -this.IPMT(taxa, periodo, totalParcelas, totalInvestido);

          ipmt = Math.round(ipmt * 100) / 100;

          if (periodo >= 1 && periodo < 6) aliqIR = 0.225;
          else if (periodo >= 6 && periodo < 12) aliqIR = 0.2;
          else if (periodo >= 12 && periodo < 24) aliqIR = 0.175;
          else aliqIR = 0.15;

          IR = ipmt * aliqIR;
          IR = Math.round(IR * 100) / 100;

          sum += IR
        }

        this.totalLiquidoIR = sum;

        return sum;
      },

      RetornoTotalLiquido() {
        return this.totalRetornoBruto - this.totalLiquidoIR;
      },

      RetornoBruto(parcelas) {
        this.totalRetornoBruto = parcelas * this.valorParcela;

        return this.totalRetornoBruto;
      },

      Nome() {
        var nome = "",
          letra = "";
        if (this.User.name == undefined || this.User.name == null || this.User.name == "") {
          nome = this.User.username;
        } else {
          nome = this.User.name;
        }
          nome = nome.trim();
        var primeiroNome = nome.split(" ")[0];
        return primeiroNome[0].toUpperCase() + primeiroNome.toLowerCase().substring(1);
      },
      recalcValues() {
				
				this.values = [];
				let quantidade = (this.loanRequest.InvestimentoMaximo / this.loanRequest.InvestimentoMinimo);
				for(let i=1; i <= quantidade; i++) {
					this.values.push("R$ " + (this.loanRequest.InvestimentoMinimo * i).toLocaleString('pt-BR', {minimumFractionDigits: "2", maximumFractionDigits: 2}) );
				}

			},
    },
    watch: {
      selected: function () {
         this.CalculaInformacoesGerais(); 
         this.MostrarRelatorio();
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/components/CompanyProfile/InvestmentReservationData.vue